/**
 * 服务发布消息组件
 */

import {
    Flex,
} from 'antd';
import { CurrentTime } from '../incs/FunHelper';

const ServiceReleaseMessage = (props) => {
    return <Flex justify='center' style={{
        textAlign: 'center',
        fontSize: '12px',
        background: 'linear-gradient(to top, #00152A,' + props.themeColor + ')',
        color: '#fff',
        height: 20.5,
        opacity: 1,
    }}
    ><span>{props.serInfos.length > 0 && CurrentTime() < props.serInfos[0].cutoff_time ? props.serInfos[0].content : ''}</span></Flex>
}

export default ServiceReleaseMessage;